import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';

export const UnitsBreadcrumb: BreadcrumbComponentType<'memberId'> = () => {
	const { t } = useTranslation('Common');
	return <NavLink to={'/courses'}>{t('Courses')}</NavLink>;
};
